import React from 'react';
import { useParams } from 'react-router-dom';

import { useConsultation } from 'api';
import { useIsMobile } from '@tq/ui-components/dist/hooks';
import { DesktopResponses, MobileResponses } from '..';
import { useResponse } from '../../hooks';

export const ArchivedConsultationResponse: React.FC = () => {
  const { id } = useParams();
  const consultationId = +(id ?? 0);
  const { data: consultation, isLoading, isInitialLoading } = useConsultation(consultationId);
  const { pastResponses, otherAnswers, pastAnswers } = useResponse(consultationId);

  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <MobileResponses
        pastResponses={pastResponses}
        otherAnswers={otherAnswers}
        pastAnswers={pastAnswers}
        consultation={consultation}
        isLoading={isInitialLoading && isLoading}
      />
    );
  } else {
    return (
      <DesktopResponses
        pastResponses={pastResponses}
        pastAnswers={pastAnswers}
        otherAnswers={otherAnswers}
        consultation={consultation}
        isLoading={isInitialLoading && isLoading}
      />
    );
  }
};
